// Module
var code = "<div class=\"search-input close-input\"> <span class=\"material-icons search-icon\" id=\"text-search-submit\">search</span> <input class=\"_searchContent z-depth-1\" type=\"text\" placeholder=\"Search\"/> <span class=\"material-icons clear-icon _closeIcon\" style=\"display:none\">clear</span> </div> ";
// Exports
export default code;